//虚线
export class LaneDividerLine{
	//lineWidth: 线宽, isDashed: 是否虚线，totalLanes:总共车道数, laneNo:车道位置， -1为右道紧急停车带,-2为左道紧急停车带，0为右幅1-2道，向左递增， startStake：起始桩号，endStake：终止桩号
	constructor(lineWidth, isDashed, laneNo, totalLanes, startStake, endStake, roadStakes){
		this.lineWidth = lineWidth;
		this.isDashed = isDashed;
		this.laneNo = laneNo;
		this.totalLanes = totalLanes;
		this.startStake = startStake;
		this.endStake = endStake;
		this.roadStakes = roadStakes;

		this.EmeZoneWidth = 2.5; //预设紧急停车带宽度
	    this.LaneWidth = 3.75;	//预设车道宽度

	}


}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/models/LaneDividerLine.js